<template>
  <div>
    <v-card elevation="2" class="mb-10">
      <v-card-title class="card-title-style">
        <div>Pricing options</div>
        <div class="ml-auto d-flex flex-row">
          <v-tooltip v-if="!isChildProposal" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="ml-1">
                <v-btn color="green" @click="addPricingPlan" icon>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </template>
            <span>Add pricing option</span>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-card-text>
        <div v-if="isEmptyObj">
          <div style="height: 100%;">
            <v-card
              elevation="2"
              class="pa-3 py-5 mt-5 black--text "
              v-for="(pricingPlan) in expansionPanelContent"
              :key="pricingPlan.id"
            >
              <div class="d-flex flex-row">
                <div>
                  <v-card-title class="pb-0 pt-0">
                    {{ pricingPlan.name }}
                    <span v-if="(pricingPlan.childProposalId || pricingPlan.proposalId) === proposalId" class="ml-2 proposal-mark current">
                      CURRENT
                    </span>
                    <span v-if="pricingPlan.isParentProposal" class="ml-2 proposal-mark parent">
                      PARENT
                    </span>
                  </v-card-title>
                  <v-card-text class="pt-0 pb-0 d-flex flex-column">
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            class="d-flex flex-row align-center"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-arrow-left-right</v-icon>
                            <div class="d-flex flex-row">
                              <div class="mx-1">
                                Delta: {{ pricingPlan.effortsDelta + "%" }}
                              </div>
                            </div>
                          </div>
                        </template>
                        <span>Change in efforts</span>
                      </v-tooltip>
                      <div class="d-flex flex-row align-center mr-1">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <div class="d-flex">
                                <v-icon>mdi-calendar-clock</v-icon>
                                <div class="mx-1">
                                  {{ pricingPlan.totalHours != null && pricingPlan.totalHours >= 0 ? pricingPlan.totalHours + "hrs" : '' }}
                                </div>
                              </div>
                            </div>
                          </template>
                          <span>Total hours</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <div class="d-flex">
                                <div class="mx-1">
                                  {{ pricingPlan.totalPrice != null && pricingPlan.totalPrice >= 0 ? pricingPlan.totalPrice.toFixed(2) + "$" : '' }}
                                </div>
                              </div>
                            </div>
                          </template>
                          <span>Total price</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              <div class="d-flex">
                                <div class="mx-1" :style="{ background: pricingPlan.rgbColumnColor }">
                                  {{ pricingPlan.rgbColumnColor }}
                                </div>
                                <v-icon>mdi-palette</v-icon>
                              </div>
                            </div>
                          </template>
                          <span>Color in DOC</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </v-card-text>
                </div>
                <div class="ml-auto my-auto">
                  <v-btn
                    v-if="(pricingPlan.childProposalId || pricingPlan.proposalId) !== proposalId"
                    class="color-blue"
                    @click="$router.push(`/proposals/${pricingPlan.childProposalId || pricingPlan.proposalId}`)"
                    icon
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn
                    class="color-green"
                    @click="editPricingPlan(pricingPlan)"
                    icon
                    v-if="!isChildProposal"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    class="color-red"
                    @click="deleteAlert(pricingPlan.id)"
                    icon
                    v-if="!isChildProposal"
                  >
                    <v-icon>mdi-delete-empty-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </div>
        </div>
        <v-card class="black--text mt-5" v-else>
          <div class="red--text no-data-block">No data found!</div>
        </v-card>
      </v-card-text>
    </v-card>
    
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEditing ? 'Edit pricing option' : 'Add pricing option' }}</span>
        </v-card-title>
        <v-form ref="form" v-model="formValid">
          <v-card-text class=" pb-0 pr-5">
            <v-row no-gutters class="d-flex justify-center">
              <v-col class="d-flex justify-center align-center" cols="12">
                <v-col no-gutters>
                  <v-textarea
                    label="Enter option name "
                    auto-grow
                    outlined
                    rows="1"
                    row-height="15"
                    :rules="[rules.required]"
                    v-model="editedItem.name"
                  ></v-textarea>
                  <v-textarea
                    label="Enter delta of efforts %"
                    auto-grow
                    outlined
                    rows="1"
                    row-height="15"
                    :rules="[rules.required, rules.numeric]"
                    v-model="editedItem.effortsDelta"
                  ></v-textarea>
                  <v-textarea
                    label="Enter order "
                    auto-grow
                    outlined
                    rows="1"
                    row-height="15"
                    :rules="[rules.required, rules.numeric]"
                    v-model="editedItem.orderIndex"
                  ></v-textarea>
                  <v-switch class="mt-3 ml-2" v-model="editedItem.isParentProposal" label="Is it parent proposal?" inset></v-switch>
                </v-col>
                <v-col>
                  <v-color-picker
                    v-model="editedItem.rgbColumnColor"
                    label="Select pricing option color"
                    hide-alpha
                    format="hex"
                    class="ml-4"
                  ></v-color-picker>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">
              Close
            </v-btn>
            <v-btn color="primary" @click="submitForm">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import axiosInstance from "@/axios";

export default {
  data: () => ({
    entity: "proposal",
    single: "Pricing plan",
    expansionHeader: null,
    editedItem: {},
    isEditing: false,
    dialog: false,
    formValid: true,
    rules: {
      required: v => v === 0 || !!v || 'This field is required',
      numeric: v => v === '' || !isNaN(Number(v)) || 'Must be a number'
    },
  }),
  computed: {
    isEmptyObj: function() {
      if (this.expansionPanelContent) {
        let isEmpty = _.isEmpty(this.expansionPanelContent);
        return !isEmpty;
      }
      return null;
    },
    expansionPanelContent: function() {
      return this.$store.state.pricingPlans;
    },
    // TESTME
    getAnchour() {
      return this.$store.state.anchour;
    },
    getUrl() {
      return this.$router.currentRoute.path;
    },
    proposalId() {
      return Number(this.$route.params.id);
    },
    isChildProposal() {
      return this.$store.state.isChildProposal;
    },
  },
  async created() {
    scroll(0, 0);
    await this.refreshData();
    this.goTo();
  },
  methods: {
    // TESTME
    goTo() {
      var vm = this;
      if (
        _(this.getUrl).includes("pricing-plans") &&
        vm.getAnchour &&
        this.expansionPanelContent.length
      ) {
        setTimeout(function() {
          vm.$vuetify.goTo("." + vm.getAnchour, { offset: 0 });
          vm.$store.commit("setAnchour", "");
        }, 500);
      }
    },
    setAnchour(anchour, curId) {
      let id = _(anchour)
        .split("-")
        .pop();
      if (id == curId) {
        return "a-" + curId;
      } else {
        return null;
      }
    },
    deleteAlert(pricingPlanId) {
      this.$swal({
        title: "Do you want to delete this pricing plan?",
        showDenyButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletePricingPlan(pricingPlanId);
        } else if (result.isDenied) {
          return;
        }
      });
    },
    async deletePricingPlan(pricingPlanId) {
      try {
        await axiosInstance.delete(
          `/proposal/${this.proposalId}/package/packages/${pricingPlanId}`
        );

        await this.refreshData();
      } catch (err) {
        console.log(err);
      }
    },
    addPricingPlan() {
      this.editedItem = {
        orderIndex: 0,
        name: '',
        effortsDelta: 0,
        rgbColumnColor: '#ffffff',
        isParentProposal: false
      };
      this.isEditing = false;
      this.dialog = true;
    },
    editPricingPlan(pricingPlan) {
      this.editedItem = { ...pricingPlan };
      this.isEditing = true;
      this.dialog = true;
    },
    createPricingPlan() {
      return axiosInstance.post(`/proposal/${this.proposalId}/package/packages`, {
        name: this.editedItem.name,
        orderIndex: Number(this.editedItem.orderIndex),
        effortsDelta: Number(this.editedItem.effortsDelta),
        rgbColumnColor: this.editedItem.rgbColumnColor,
        isParentProposal: this.editedItem.isParentProposal,
      });
    },
    updatePricingPlan() {
      return axiosInstance.put(
        `/proposal/${this.proposalId}/package/packages/${this.editedItem.id}`,
        {
          name: this.editedItem.name,
          orderIndex: Number(this.editedItem.orderIndex),
          effortsDelta: Number(this.editedItem.effortsDelta),
          rgbColumnColor: this.editedItem.rgbColumnColor,
          isParentProposal: this.editedItem.isParentProposal,
        }
      );
    },
    closeDialog() {
      this.dialog = false;
      this.editedItem = {};
      this.isEditing = false;
      this.$refs.form?.resetValidation();
    },
    async submitForm() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) return;

      if (this.isEditing) {
        await this.updatePricingPlan();
      } else {
        await this.createPricingPlan();
      }

      this.closeDialog();
      await this.refreshData();
    },
    viewPricingPlan(pricingPlanId) {
      console.log("Pricing plan with ID:", pricingPlanId);
    },
    async refreshData() {
      await this.$store.dispatch("refreshPricingPlans", this.$route.params.id);
      await this.$store.dispatch("refreshPricingPlansItems", this.$route.params.id);
    },
  },
};
</script>

<style scoped>
.block-subtitle::first-letter {
  text-transform: uppercase;
}
.proposal-mark {
  padding: 0 6px;
  border-radius: 4px;
  color: #FFFFFF !important;
  letter-spacing: 0.5px;
}
.current {
  background: rgb(76, 175, 80) !important;
}
.parent {
  background: rgb(33, 150, 243) !important;
}
.no-data-block{
  height: 8vh;
  padding-top: 2vh;
  text-align: center;
}
</style>
